<template>
  <div>
    <v-card elevation="0">
      <v-toolbar flat>
        <v-toolbar-title class="info--text font-weight-bold text--darken-1 justify-center">
          <span>{{ showUpcomingVisits ? "Today's" : "Past" }} Visits</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <div>
          <v-select 
            v-model="selectedHeaders" 
            :items="visitHeaders" 
            label="Column Visibility" 
            multiple 
            outlined 
            return-object
            dense
            class="mt-6"
            @change="toggleColumnVisibility"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 2" class="grey--text caption">(+{{ selectedHeaders.length - 2 }} others)</span>
            </template>
         </v-select>
        </div>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-hover v-slot="{ hover }">
              <v-btn :class="{ 'green--text': hover }" icon v-bind="attrs" v-on="on" @click="showUpcomingVisit">
                <v-icon color="green">mdi-sort-calendar-descending</v-icon>
              </v-btn>
            </v-hover>
          </template>
          <span class="text-caption">Upcoming Visits</span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-hover v-slot="{ hover }">
              <v-btn :class="{ 'red--text': hover }" icon v-bind="attrs" v-on="on" @click="showPastVisit">
                <v-icon color="red">mdi-sort-calendar-ascending</v-icon>
              </v-btn>
            </v-hover>
          </template>
          <span class="text-caption">Past Visits</span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-hover v-slot="{ hover }">
              <v-btn :class="{ 'info--text': hover }" icon v-bind="attrs" v-on="on" @click="scheduleModal">
                <v-icon color="info">mdi-calendar-plus</v-icon>
              </v-btn>
            </v-hover>
          </template>
          <span class="text-caption">Add Visit</span>
        </v-tooltip>

      </v-toolbar>

      <v-divider></v-divider>

      <v-data-table
        :headers="computedHeaders" 
        :items="visits" 
        sort-by="name" 
        class="elevation-1"
        loading-text="Loading... Please wait" 
        :search="filterReportBySearch" 
        show-select 
        :single-select="singleSelect"
        v-model="selected"
        :server-items-length="visitsPagination?.total"
        :options.sync="options"
      >
        <template v-slot:top>
          <v-progress-linear indeterminate color="info" v-if="loading"></v-progress-linear>
          <v-divider></v-divider>
        </template>

        <template v-slot:[`item.id`]="{ index }">
          {{ ++index }}
        </template>

        <template v-slot:[`item.event_date`]="{ item }">
          {{ formatDate(item.event_date) }}
        </template>

        <template v-slot:[`item.time`]="{ item }">
          {{ item.start_at }} - {{ item.end_at }}
        </template>
      </v-data-table>
    </v-card>

    <!-- Schedule Visit Modal -->
    <ScheduleVisitModal 
      v-model="showScheduleModal"
      :organization-facilities="organizationFacilities"
      :organization="organization"
      @get_upcoming_visits="getUpcomingVisits"
    />
  </div>
</template>
<script>
import organizationService from '../../services/organization.service';
import ReportsService from '../../services/reports.service';
import moment from 'moment';
import ScheduleVisitModal from '../../components/ScheduleVisitModal.vue';

export default {
  name: "ScheduleVisit",

  components: {
    ScheduleVisitModal
  },

  props: [
    'organization'
  ],

  data() {
    return {
      visits: [],
      visitsPagination: {},
      selected: [],
      singleSelect: false,
      filterReportBySearch: null,
      options: {},
      loading: false,
      selectedHeaders: [],
      visitHeaders: [
        {
          text: "#",
          value: "id",
          visible: true,
        }, 
        {
          text: "Visitor",
          align: "start",
          filterable: true,
          value: "visitor.name",
          visible: true,
        },
        {
          text: "Host",
          value: "host.name",
          filterable: false,
          visible: true,
        },
        {
          text: "Title",
          value: "title",
          filterable: false,
          visible: false,
        },
        {
          text: "Reason",
          value: "reason",
          filterable: false,
          visible: false,
        },
        {
          text: "Location",
          value: "facility",
          filterable: false,
          visible: true,
        },
        {
          text: "Date",
          align: "center",
          value: "event_date",
          filterable: false,
          visible: true,
        },
        {
          text: "Time",
          align: "center",
          value: "time",
          filterable: false,
          visible: true,
        },
        {
          text: "Status",
          value: "attend_status",
          filterable: false,
          visible: true,
        },
      ],
      showUpcomingVisits: true,
      showScheduleModal: false,
      apiErrors: [],
      visitCategories: ["Official", "Personal"],
      closeOnContentClick: false,
      dateToday: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      national_number: "KE",
      phoneNumber: null,
      phoneValidationError: null,
      organizationFacilities: [],
      valid: false,
    }
  },

  computed: {
    organizationFacility() {
      return this.organization.facility[0] ?? { 'id': null, 'facility': null };
    },

    visitsWithIndex() {
      if ((this.visits).length == 0) {
        return [];
      }

      return this.visits.map(
        (visits, index) => ({
          ...visits,
          index: index + 1
        })
      );
    },

    computedHeaders() {
      let headers = this.visitHeaders.filter((item) => (item.visible == true));
      return headers;
    },
  },

  created() {
    this.$nextTick(() => {
      this.selectedHeaders = this.computedHeaders;
      this.getUpcomingVisits();
      this.getPastVisits();
      this.getOrganizationFacilities();
    });
  },

  methods: {
    toggleColumnVisibility() {
      if (this.selectedHeaders && this.selectedHeaders.length > 0) {
        this.visitHeaders.forEach((visitHeader) => {
          let index = -1;
          index = this.visitHeaders.findIndex((header) => header.value == visitHeader.value);
          if (index > -1) {
            this.visitHeaders[index].visible = false;
          }
        });

        this.selectedHeaders.forEach((selectedHeader) => {
          let index = -1;
          index = this.visitHeaders.findIndex((header) => header.value == selectedHeader.value);
          if (index > -1) {
            this.visitHeaders[index].visible = true;
          }
        });
      }
    },

    scheduleModal() {
      this.showScheduleModal = true;
    },

    formatDate(date, format = 'DD-MMM-YYYY') {
      return moment(date).format(format);
    },

    toggleVisits() {
      let visits = [];
      let visitsPagination = {};
      
      if (this.showUpcomingVisits) {
        visitsPagination = this.upcomingVisits ?? {};
        visits = this.upcomingVisits?.data ?? [];
      } else {
        visitsPagination = this.pastVisits ?? {};
        visits = this.pastVisits?.data ?? [];
      }
      
      this.visits = visits;
      this.visitsPagination = visitsPagination;
    },

    showUpcomingVisit() {
      this.getUpcomingVisits();
      this.showUpcomingVisits = true;
      this.toggleVisits();
    },

    showPastVisit() {
      this.getPastVisits();
      this.showUpcomingVisits = false;
      this.toggleVisits();
    },

    getUpcomingVisits() {
      this.loading = true;
      ReportsService.upcomingVisits(this.organization.id, { options: this.options }).then(
        success => {
          this.upcomingVisits = success.data ? success.data.data : this.upcomingVisits
          this.toggleVisits();
          this.loading = false;
        },
        error => {
          console.log(error)
          this.upcomingVisits = [];
          this.loading = false;
        }
      )
    },

    getPastVisits() {
      this.loading = true;
      ReportsService.pastVisits(this.organization.id, { options: this.options }).then(
        success => {
          this.pastVisits = success.data.data;
          this.toggleVisits();
          this.loading = false;
        },
        error => {
          console.log(error)
          this.pastVisits = [];
          this.loading = false;
        }
      )
    },

    getOrganizationFacilities() {
      organizationService.organization_facilities(this.organization.id).then(
        success => {
          this.organizationFacilities = success.data ? success.data.data : [];
        },
        error => {
          console.log(error)
          this.organizationFacilities = [];
        }
      )
    },
  },
  watch: {
    options: {
      handler () {
        if (this.showUpcomingVisits) {
          this.getUpcomingVisits();
        } else {
          this.getPastVisits();
        }
      },
      deep: true,
    },
  },
}
</script>